const inputStyle = Object.freeze({
  borderWidth: 1,
  lines: 1,
  borderStyle: 'solid',
  radius: 0,
  height: 6,
  // typographic Scale from theme
  typeScale: 0,
  fontWeightLabel: 'bold',
});

export default inputStyle;
